import React, { useContext, useEffect, useState } from "react";
import { SvgImages } from "../../Utils/LocalImages";
import ButtonWithIcon from "../../Components/Reusable/ButtonWithIcon";
import CustomTextField from "../../Components/Reusable/CustomTextField";
import { InputType, handleApiErrors, validationRegex } from "../../Utils/Utils";
import { useNavigate } from "react-router-dom";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import DynamicService from "../../Services/DynamicService";
import { AuthContext } from "../../Context/authContext";

const SocialMediaContact = () => {
  const [socialdata, setSocialdata] = useState({});
  const navigate = useNavigate();
  const {user} = useContext(AuthContext)

  const Validations = yup.object().shape({
    phone: validationRegex.required,
    instagram: validationRegex.required,
    twitter: validationRegex.required,
    youtube: validationRegex.required,
    facebook: validationRegex.required,
    linkedin: validationRegex.required,
    email: validationRegex.required,
    day: validationRegex.required,
    time: validationRegex.required,
  });

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
    reset,
  } = useForm({
    resolver: yupResolver(Validations),
    defaultValues: {
      phone: "",
      instagram: "",
      twitter: "",
      youtube: "",
      facebook: "",
      linkedin: "",
      email: "",
      day: "",
      time: "",
    },
  });

  useEffect(() => {
    getSocialContactInfo();
  }, []);

  const getSocialContactInfo = async () => {
    try {
      const response = await DynamicService.getSocialContactInfo();
      const data = response.data;
      setSocialdata(data);
      setValue("facebook", data.facebook);
      setValue("instagram", data.instagram);
      setValue("linkedin", data.linkedin);
      setValue("twitter", data.twitter);
      setValue("youtube", data.youtube);
      setValue("phone", data.phone);
      setValue("email", data.email);
      setValue("day", data.day);
      setValue("time", data.time);
    } catch (error) {
      handleApiErrors(error);
    }
  };

  const onSubmit = async (data) => {
    const dynamicPrivilege = user?.setPrivileges?.find(
      (priv) => priv.parameter === "Dynamic"
    );

    if (dynamicPrivilege?.update) {
      try {
        await DynamicService.updateSocialContactInfo(data);
        toast.success("Data Updated Successfully!");
      } catch (error) {
        handleApiErrors(error);
      }
    } else {
      toast.warning("You don't have permission to update social media & contact details.");
    }
  };

  return (
    <div>
      <div className="mb-3 d-flex justify-content-between align-items-center">
        <h1 className="black fs-18 fw-600 mb-0">
          SOCIAL MEDIA & CONTACT DETAILS
        </h1>
        <div className="d-flex">
          <h4 className="fs-12 fw-500 black mb-0 me-1">Dashboard &gt;</h4>
          <h4 className="fs-12 fw-500 primary mb-0">
            Social Media & Contact Details
          </h4>
        </div>
      </div>
      <div className="table_container" style={{ display: "block" }}>
        <div className="table_title">
          <div className="table_headings">
            <h1 className="black fs-18 fw-600 mb-0">
              Social Media & Contact Details
            </h1>
          </div>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="fs-16 fw-600 mt-4 blue">Social Media</div>
            <div className="row profile_inputs w-100 mt-3">
              <div className="col-md-6">
                <CustomTextField
                  labelTitle="Facebook"
                  placeholder="Facebook Link"
                  name="facebook"
                  id="facebook"
                  additionalClasses="profile_edit"
                  inputType={InputType.text}
                  showMandatory={true}
                  register={register}
                  showError={errors?.facebook}
                  errorMessage={errors?.facebook?.message}
                  defaultValue={socialdata?.facebook || ""}
                />
              </div>
              <div className="col-md-6">
                <CustomTextField
                  labelTitle="Instagram"
                  placeholder="Instagram Link"
                  name="instagram"
                  id="instagram"
                  additionalClasses="profile_edit"
                  inputType={InputType.text}
                  showMandatory={true}
                  register={register}
                  showError={errors?.instagram}
                  errorMessage={errors?.instagram?.message}
                  defaultValue={socialdata?.instagram || ""}
                />
              </div>
              <div className="col-md-6">
                <CustomTextField
                  labelTitle="LinkedIn"
                  placeholder="LinkedIn Link"
                  name="linkedin"
                  id="linkedin"
                  additionalClasses="profile_edit"
                  inputType={InputType.text}
                  showMandatory={true}
                  register={register}
                  showError={errors?.linkedin}
                  errorMessage={errors?.linkedin?.message}
                  defaultValue={socialdata?.linkedin || ""}
                />
              </div>
              <div className="col-md-6">
                <CustomTextField
                  labelTitle="Twitter"
                  placeholder="Twitter Link"
                  name="twitter"
                  id="twitter"
                  additionalClasses="profile_edit"
                  inputType={InputType.text}
                  showMandatory={true}
                  register={register}
                  showError={errors?.twitter}
                  errorMessage={errors?.twitter?.message}
                  defaultValue={socialdata?.twitter || ""}
                />
              </div>
              <div className="col-md-6">
                <CustomTextField
                  labelTitle="Youtube"
                  placeholder="Youtube Link"
                  name="youtube"
                  id="youtube"
                  additionalClasses="profile_edit"
                  inputType={InputType.text}
                  showMandatory={true}
                  register={register}
                  showError={errors?.youtube}
                  errorMessage={errors?.youtube?.message}
                  defaultValue={socialdata?.youtube || ""}
                />
              </div>
              <div className="fs-16 fw-600 mt-3 blue mb-3">Contact Details</div>
              <div className="col-md-6">
                <CustomTextField
                  labelTitle="Phone No."
                  placeholder="Phone No."
                  name="phone"
                  id="phone"
                  additionalClasses="profile_edit"
                  inputType={InputType.text}
                  showMandatory={true}
                  register={register}
                  showError={errors?.phone}
                  errorMessage={errors?.phone?.message}
                  defaultValue={socialdata?.phone || ""}
                />
              </div>
              <div className="col-md-6">
                <CustomTextField
                  labelTitle="Email Id"
                  placeholder="Email Id"
                  name="email"
                  id="email"
                  additionalClasses="profile_edit"
                  inputType={InputType.email}
                  showMandatory={true}
                  register={register}
                  showError={errors?.email}
                  errorMessage={errors?.email?.message}
                  defaultValue={socialdata?.email || ""}
                />
              </div>
              <div className="col-md-6">
                <CustomTextField
                  labelTitle="Day"
                  placeholder="Select a day"
                  name="day"
                  id="day"
                  additionalClasses="profile_edit"
                  inputType={InputType.text}
                  showMandatory={true}
                  register={register}
                  showError={errors?.day}
                  errorMessage={errors?.day?.message}
                  defaultValue={socialdata?.day || ""}
                />
              </div>
              <div className="col-md-6">
                <CustomTextField
                  labelTitle="Time"
                  placeholder="Select a start time"
                  name="time"
                  id="time"
                  additionalClasses="profile_edit"
                  inputType={InputType.text}
                  showMandatory={true}
                  register={register}
                  showError={errors?.time}
                  errorMessage={errors?.time?.message}
                  defaultValue={socialdata?.time || ""}
                />
              </div>
              <div className="d-flex justify-content-end">
                <ButtonWithIcon
                  text={"Update"}
                  icon={SvgImages.tick_mark}
                  onClick={handleSubmit(onSubmit)}
                />
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default SocialMediaContact;
